export const toQueryString = params => {
  const str = Object.entries(params)
    .filter(([, value]) => value !== false)
    .map(([key, value]) => value === true ? key : `${key}=${value}`)
    .join('&');

  return str ? `?${str}` : '';
};